/* BSW Produktkarte – Farbe + Größe wählen, CTA verlinkt direkt auf die Variante */
(function () {
  if (customElements.get('bsw-card-picker')) return;

  class BswCardPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const data = this.querySelector('script[data-variants]');
      try {
        this.variants = JSON.parse(data ? data.textContent : '[]');
      } catch (e) {
        this.variants = [];
      }
      this.ci = parseInt(this.dataset.colorIndex, 10);
      this.si = parseInt(this.dataset.sizeIndex, 10);
      this.color = this.dataset.defaultColor || null;
      this.size = null;
      this.touched = false;

      this.cta = this.querySelector('[data-cta]');
      this.ctaSel = this.querySelector('[data-cta-sel]');
      this.colorLabel = this.querySelector('[data-color-label]');
      this.baseHref = this.cta ? this.cta.getAttribute('href') : null;

      const card = this.closest('.bsw-card');
      this.img = card ? card.querySelector('.bsw-card__img') : null;
      if (this.img) {
        this.imgOrig = {
          src: this.img.getAttribute('src'),
          srcset: this.img.getAttribute('srcset'),
        };
      }

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-opt]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        this.touched = true;
        if (btn.dataset.opt === 'color') {
          this.color = btn.dataset.value;
          this.swapImage();
        } else {
          this.size = this.size === btn.dataset.value ? null : btn.dataset.value;
        }
        this.render();
      });

      this.render();
    }

    find(color, size, onlyAvailable) {
      return this.variants.find((v) =>
        (this.ci < 0 || color === null || v.o[this.ci] === color) &&
        (this.si < 0 || size === null || v.o[this.si] === size) &&
        (!onlyAvailable || v.a)
      );
    }

    swapImage() {
      if (!this.img || this.ci < 0) return;
      const withImg = this.variants.find((v) => v.o[this.ci] === this.color && v.img);
      if (withImg) {
        this.img.removeAttribute('srcset');
        this.img.setAttribute('src', withImg.img);
      } else if (this.imgOrig) {
        this.img.setAttribute('src', this.imgOrig.src);
        if (this.imgOrig.srcset) this.img.setAttribute('srcset', this.imgOrig.srcset);
      }
    }

    render() {
      this.querySelectorAll('button[data-opt="color"]').forEach((b) => {
        const on = b.dataset.value === this.color;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (this.colorLabel && this.color) this.colorLabel.textContent = this.color;

      this.querySelectorAll('button[data-opt="size"]').forEach((b) => {
        const val = b.dataset.value;
        const available = !!this.find(this.color, val, true);
        b.disabled = !available;
        if (!available && this.size === val) this.size = null;
        const on = this.size === val;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (!this.cta || !this.baseHref) return;

      const parts = [];
      if (this.size) parts.push(this.size);
      if (this.touched && this.color && this.ci > -1) parts.push(this.color);
      if (this.ctaSel) this.ctaSel.textContent = parts.length ? '· ' + parts.join(' · ') : '';

      const url = new URL(this.baseHref, window.location.origin);
      if (this.touched) {
        const v = this.find(this.color, this.size, true) || this.find(this.color, this.size, false);
        if (v) url.searchParams.set('variant', v.id);
      }
      this.cta.setAttribute('href', url.pathname + url.search);
    }
  }

  customElements.define('bsw-card-picker', BswCardPicker);
})();
